<template>
  <QuadroPrincipal
    v-if="dadosResultado.id_imposto == 100"
    class="antecipacao-container"
    :classe="classe"
    :titulo="'COM ENCERRAMENTO'"
  >
    <Registro :key="`antecipacaoRender${getRenderKey}`">
      <Cabecalho paddingBottom :titulo="dadosResultado.label" />
      <Inaplicabilidade :texto="dadosResultado.texto_inaplicabilidade" />
    </Registro>
  </QuadroPrincipal>

  <QuadroPrincipal
    v-else
    :key="`antecipacaoRender${getRenderKey}`"
    :classe="classe"
    :titulo="'COM ENCERRAMENTO'"
  >
    <Registro paddingSemCheckBox>
      <Cabecalho v-if="tituloNegrito" nowrap :tipo="'html'" paddingBottom :titulo="tituloNegrito" />
      <Descricao :titulo="'Segmento'" :descricao="dadosResultado.segmento" />
      <div v-if="tituloNegrito || dadosResultado.segmento" class="separador" />
      <Ncm :ncm="dadosResultado.ncm" />
      <div v-if="dadosResultado.ncm" class="separador" />

      <Descricao paddingBottom :titulo="'Descrição'" :descricao="dadosResultado.descricao" />

      <!-- AJUSTAR AS PROCA PARA TRAZER MVA APENAS NA BASE PARA USAR APENAS UM REGISTRO DE MVA -->
      <Registro v-if="(!!dados.base && !!dados.base.length) || dadosResultado.mva">
        <RegistrosMva
          :classe="classe"
          :dados="dados.base.length ? dados.base : dadosMva"
          :mvaSelecionado="mvaSelecionado"
          :selecionouMva="selecionouMva"
          :seleciona="selecionaMva"
          :edita="editaMva"
        />
        <div v-if="!dados.base.length || selecionouMva">
          <Notificacao
            v-if="!!dadosResultado.alerta_excecao"
            :tipo="'alerta'"
            :texto="dadosResultado.alerta_excecao"
          />
          <GrupoNotificacao v-if="dadosResultado" :registro="dadosResultado" />
          <div
            v-if="
              dadosResultado.cest &&
                (dadosResultado.alerta_excecao ||
                  dadosResultado.obs_aplic ||
                  dadosResultado.obs_inaplic ||
                  dadosResultado.obs)
            "
            class="separador"
          />
          <Cabecalho
            v-if="dadosResultado.cest"
            paddingBottom
            tipo="ncm"
            :titulo="'CEST (Convênio ICMS 142/2018)'"
            :aliquota="dadosResultado.cest"
          />
          <Notificacao
            v-if="!!dadosResultado.alerta && dadosResultado.cest"
            :tipo="'alerta'"
            :texto="dadosResultado.alerta"
          />
        </div>
      </Registro>
      <!-- FIM -->

      <BaseLegal
        v-if="dadosResultado.base_legal_adicional_sn"
        :base_legal="dadosResultado.base_legal_adicional_sn"
        :classe="classe"
      />

      <div
        v-if="(dadosResultado.mva && !dados.base) || dadosResultado.base_legal_adicional_sn"
        class="separador"
      />

      <div
        v-if="(dadosResultado.cest || dadosResultado.alerta) && dadosResultado.base_legal"
        class="separador"
      />

      <BaseLegal
        v-if="dadosResultado.base_legal"
        :base_legal="dadosResultado.base_legal"
        :classe="classe"
      />
    </Registro>
  </QuadroPrincipal>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import QuadroZebra from "@/components/QuadroZebra/QuadroZebra.vue";
import Registro from "@/components/Registro/Registro.vue";
import RegistrosMva from "@/components/RegistrosMva/RegistrosMva";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Observacoes from "@/components/Observacoes/Observacoes.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import Ncm from "../Ncm/Ncm.vue";

import { mapGetters } from "vuex";

export default {
  name: "ResultadoAntecipacao",

  mixins: [stringFormatMixin],

  props: {
    dados: Object | Array,
    classe: String,
    selecionaMva: Function,
    editaMva: Function,
    mvaSelecionado: Object | Array,
    selecionouMva: Boolean
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    Inaplicabilidade,
    QuadroPrincipal,
    QuadroZebra,
    GrupoNotificacao,
    Registro,
    RegistrosMva,
    Notificacao,
    Observacoes,
    Ncm
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    dadosMva() {
      if (this.dadosResultado.base_calculo_antecipacao && this.dadosResultado.mva) {
        return [
          {
            base_calculo_antecipacao: this.dadosResultado.base_calculo_antecipacao,
            mva: Number(this.dadosResultado.mva) != 0 ? this.dadosResultado.mva : "-"
          }
        ];
      }
      return null;
    },
    dadosResultado() {
      return this.dados.dados[0];
    },

    tituloNegrito() {
      const negritoSubstituição = this.strReplace(
        this.dadosResultado.titulo,
        "Substituição Tributária",
        "<b>Substituição Tributária</b>"
      );
      const negritoSubstituto = this.strReplace(
        negritoSubstituição,
        "Substituto Tributário",
        "<b>Substituto Tributário</b>"
      );
      const negritoResponsável = this.strReplace(
        negritoSubstituto,
        "Responsável Tributário",
        "<b>Responsável Tributário</b>"
      );
      const removePonto = this.strReplace(negritoResponsável, "• ", "");
      return removePonto;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
// .separador {
//   margin-top: 1rem;
// }

.registro-content {
  margin-bottom: 7px;

  label {
    margin-bottom: 2rem;
    font-size: 1rem;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
@media only print {
  .antecipacao-container {
    padding-left: 10px;
    page-break-inside: avoid;
  }
}
</style>
